// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-search-filter{position:sticky;top:0}.text-search-filter.v-input{margin-top:0!important}.text-search-filter .v-input__control>.v-input__slot:after,.text-search-filter .v-input__control>.v-input__slot:before{display:none!important}.text-search-filter .v-input__prepend-outer{margin-right:.2rem!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
